import { render, staticRenderFns } from "./Subscribers.vue?vue&type=template&id=08125d68&scoped=true"
import script from "./Subscribers.vue?vue&type=script&lang=js"
export * from "./Subscribers.vue?vue&type=script&lang=js"
import style0 from "./Subscribers.vue?vue&type=style&index=0&id=08125d68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08125d68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08125d68')) {
      api.createRecord('08125d68', component.options)
    } else {
      api.reload('08125d68', component.options)
    }
    module.hot.accept("./Subscribers.vue?vue&type=template&id=08125d68&scoped=true", function () {
      api.rerender('08125d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Notifications/Subscribers.vue"
export default component.exports